/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListReportEdc from '../views/report-edc/ListReportEdc.vue';
import { setBreadcrumb } from './index';

const reportEdcRoute = {
  path: '/report-edc',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Report EDC',
        appBarTitle: 'Report EDC',
        breadcrumbs: () => [
          setBreadcrumb('Report EDC', '/report-edc', true),
          setBreadcrumb('List Report EDC', '/report-edc'),
        ],
      },
      component: ListReportEdc,
      name: 'ListReportEdc',
    },
  ],

  meta: {
    title: 'BNI QRIS - Report EDC',
    appBarTitle: 'Report EDC',
  },
  component: Parent,
};

export default reportEdcRoute;
